// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-pagination__jump[data-v-132d25ee]{margin-left:0}.el-tag[data-v-132d25ee]{margin-right:5px}.table-img[data-v-132d25ee]{width:30px;height:30px}", ""]);
// Exports
module.exports = exports;
